// extracted by mini-css-extract-plugin
export default {"image":"PreparationTasksImage_image__5PYnJ"};